import React from 'react';
import { NoYet } from 'components';

export const LeaderboardCardsWrapper = ({ title, children, wrapperStyle = {}, boxStyle = {}, noYetText }) => {
  return (
    <div
      className='leaderboard-cards-wrapper'
      style={wrapperStyle}
    >
      <h3 className='leaderboard-cards-title'>
        {title}
      </h3>

      <div
        className='leaderboard-cards-box'
        style={boxStyle}
      >
        {children || <NoYet position={'center'} text={`No ${noYetText || ''} Yet`} />}
      </div>
    </div>
  );
};

